import * as Constants from './constants'
import * as Types from './types'

export const changePageConstant = (prefix: string) => `${prefix}_${Constants.CHANGE_PAGE}`
export const goToPageConstant = (prefix: string) => `${prefix}_${Constants.GO_TO_PAGE}`
export const initializePageConstant = (prefix: string) => `${prefix}_${Constants.INITIALIZE_PAGE}`

export const sliceState = <T>(data: T[], page: Types.PageState): T[] => {
  return data.slice(page.skip, page.skip + page.take)
}



// WEBPACK FOOTER //
// ./src/components/pager/utils.ts